import {
  LOGGED_IN_USER_DATA,
  LOGGED_IN_USER_DATA_COOKIE,
  LOGGED_IN_TOKEN,
} from "./constant";

export const saveLoggedInData = (data) => {
  localStorage.setItem(LOGGED_IN_USER_DATA_COOKIE, JSON.stringify(data));
};

export const saveLoggedInToken = (data) => {
  localStorage.setItem(LOGGED_IN_TOKEN, JSON.stringify(data));
};

export const getLoggedInData = () => {
  const dataString = localStorage.getItem(LOGGED_IN_USER_DATA_COOKIE);

  // const dataString = Cookies.get(LOGGED_IN_USER_DATA_COOKIE);
  // console.log(dataString, "here");
  if (dataString) {
    return JSON.parse(dataString);
  }
  return null;
};

export const getLoggedInAccessToken = async () => {
  const dataString = localStorage.getItem(LOGGED_IN_TOKEN);
  if (dataString) {
    return JSON.parse(dataString);
  }
  return null;
};

export const getAccessToken = async () => {
  const data = await getLoggedInData();
  if (data) {
    return data.access_token;
  }

  return null;
};

export const getRefreshToken = () => {
  const data = getLoggedInData();
  if (data) {
    return data.refresh_token;
  }

  return null;
};
export const removeLoggedInData = () => {
  return localStorage.clear();
};

export const gotoLogin = () => {
  window.history.go("/login");
};
